module.exports = __webpack_public_path__ + "static/media/WBtext.3984e981.svg";